// extracted by mini-css-extract-plugin
var _1 = "Message_closeButton__ncq7y";
var _2 = "Message_error__7Zq4G";
var _3 = "Message_message__-fwXy";
var _4 = "Message_warning__etaCa";
export { _1 as "closeButton", _2 as "error", _3 as "message", _4 as "warning" }
